require('./slick.min.js')

jQuery(function ($) {
    // Masthead — no nav, infinite loop
    $('.slick-carousel--masthead').slick({
        infinite: true,
        autoplay: false,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
  
    // Media blocks
    $('.slick-carousel--media-blocks').each(function () {
        const $carousel = $(this);
        const $nav = $carousel.closest('.c-media-block').find('.slick-carousel__nav');
        
        $carousel.slick({
            infinite: false,
            autoplay: false,
            arrows: true,
            appendArrows: $nav,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1399,
                    settings: { slidesToShow: 2 }
                },
                {
                    breakpoint: 999,
                    settings: { slidesToShow: 1 }
                },
                {
                    breakpoint: 499,
                    settings: { slidesToShow: 1 }
                }
            ]
        });
    });
  
    // Event blocks
    $('.slick-carousel--event-block').each(function () {
        const $carousel = $(this);
        const $nav = $carousel.closest('.c-construkt-col').find('.slick-carousel__nav');
        
        $carousel.slick({
            infinite: false,
            autoplay: false,
            arrows: true,
            appendArrows: $nav,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1399,
                    settings: { slidesToShow: 2 }
                },
                {
                    breakpoint: 999,
                    settings: { slidesToShow: 1 }
                },
                {
                    breakpoint: 499,
                    settings: { slidesToShow: 1 }
                }
            ]
        });
    });
  
    // Reviews
    $('.slick-carousel--reviews').each(function () {
        const $carousel = $(this);
        const $nav = $carousel.closest('.c-construkt-col').find('.slick-carousel__nav');
      
        $carousel.slick({
          infinite: false,
          autoplay: false,
            arrows: true,
            dots: true,
          appendArrows: $nav,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1399,
              settings: { slidesToShow: 2}
            },
            {
              breakpoint: 999,
              settings: { slidesToShow: 1}
            }
          ]
        });
      });
})


// WEBPACK FOOTER //
// ./src/js/slick-carousels.js